<div mat-dialog-title class="dialog-info applied-offices-dialogInfo-header m-0" closeOnEscape>
    <label class="dialogTitle">
        {{ 'PROPERTIES_LABOR_RATES_APPLIED_OFFICES' | translate }}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>
<mat-dialog-content [formGroup]="appliedOfficesForm" class="applied-offices-dialog-content">
    <div class="row">
        <label>{{ 'PROPERTIES_LABOR_RATES_SELECT_OFFICES' | translate }}</label>
    </div>
    <div class="row col-sm-12 ">
        <div class="applied-offices-select-row">
            <mat-form-field appearance="outline" class="full-width col-sm-10 applied-offices-select-field">
                <mat-select formControlName="officeSelectionOption" (selectionChange)="onOfficeSelectionChange($event.value)">
                    @for (office of officeOptions; track office.salesOfficeId) {
                        <mat-option [value]="office.salesOfficeId">
                            {{ getOfficeName(office.salesOfficeId) }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row col-sm-12 applied-offices-table-wrapper ">
        <div class="scrollable-table-overflow">
            <table class="applied-offices-table">
                <thead>
                    <tr class="row-height applied-offices-table-header">
                        <th class="applied-offices-table-header-text">{{'PROPERTIES_LABOR_RATES_LABOR' | translate}}</th>
                        <th class="applied-offices-table-header-text text-center">{{'PROPERTIES_LABOR_RATES_STD_RATE' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- PM: Standard only -->
                    @if (isStandardRatesVisible) {
                        <tr class="row-height">
                            <td>{{'PM' | translate}}</td>
                            <td class="text-end">{{selectedRates.pm | multilingualCurrency}}</td>
                        </tr>
                    }

                    <!-- ENG: always visible -->
                    <tr class="row-height">
                        <td>{{'ENG' | translate}}</td>
                        <td class="text-end">{{selectedRates.eng | multilingualCurrency}}</td>
                    </tr>

                    <!-- EENG: Standard only -->
                    @if (isStandardRatesVisible) {
                        <tr class="row-height">
                            <td>{{'EENG' | translate}}</td>
                            <td class="text-end">{{selectedRates.eeng | multilingualCurrency}}</td>
                        </tr>
                    }

                    <!-- LENG: Standard only -->
                    @if (isStandardRatesVisible) {
                        <tr class="row-height">
                            <td>{{'LENG' | translate}}</td>
                            <td class="text-end">{{selectedRates.leng | multilingualCurrency}}</td>
                        </tr>
                    }

                    <!-- SPEC: always visible -->
                    <tr class="row-height">
                        <td>{{'SPEC' | translate}}</td>
                        <td class="text-end">{{selectedRates.spec | multilingualCurrency}}</td>
                    </tr>

                    <!-- MECH: Standard only -->
                    @if (isStandardRatesVisible) {
                        <tr class="row-height">
                            <td>{{'MECH' | translate}}</td>
                            <td class="text-end">{{selectedRates.mech | multilingualCurrency}}</td>
                        </tr>
                    }

                    <!-- ELEC: Standard or Zine -->
                    @if (isStandardRatesVisible || isZineRatesVisible) {
                        <tr class="row-height">
                            <td>{{'ELEC' | translate}}</td>
                            <td class="text-end">{{selectedRates.elec | multilingualCurrency}}</td>
                        </tr>
                    }

                    <!-- DDS: Zine only -->
                    @if (isZineRatesVisible) {
                        <tr class="row-height">
                            <td>{{'DDS' | translate}}</td>
                            <td class="text-end">{{selectedRates.dds | multilingualCurrency}}</td>
                        </tr>
                    }

                    <!-- NENG: Zine extra (not in priority order) -->
                    @if (isZineRatesVisible) {
                        <tr class="row-height">
                            <td>{{'NENG' | translate}}</td>
                            <td class="text-end">{{selectedRates.neng | multilingualCurrency}}</td>
                        </tr>
                    }

                    <!-- Eng office extras: CENG, QENG, GRAP, PROG (Zee/Zoc only) -->
                    @if (isEngOfficeRatesVisible) {
                        <tr class="row-height">
                            <td>{{'CENG' | translate}}</td>
                            <td class="text-end">{{selectedRates.ceng | multilingualCurrency}}</td>
                        </tr>
                        <tr class="row-height">
                            <td>{{'QENG' | translate}}</td>
                            <td class="text-end">{{selectedRates.qeng | multilingualCurrency}}</td>
                        </tr>
                        <tr class="row-height">
                            <td>{{'GRAP' | translate}}</td>
                            <td class="text-end">{{selectedRates.grap | multilingualCurrency}}</td>
                        </tr>
                        <tr class="row-height">
                            <td>{{'PROG' | translate}}</td>
                            <td class="text-end">{{selectedRates.prog | multilingualCurrency}}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        
    </div>

</mat-dialog-content>
<mat-dialog-actions align="end" class="applied-offices-dialog-actions">
    <button mat-raised-button color="warn" [mat-dialog-close]>{{'CLOSE' | translate}}</button>
</mat-dialog-actions>